import { InjectionToken, Type } from '@angular/core';
import { BaseCustomizableChartService } from '@common-modules/shared/charts/base-customizable-chart.service';
import { BaseCustomizableChartDataService } from 'src/app/common-modules/wlm-charts/core/customizable-chart/base-customizable-chart-data.service';

export const WLM_CHART_SETTINGS = new InjectionToken<GenericChartsModuleSettings>(
  'wlm_chart_settings'
);

export class GenericChartsModuleSettings {
  avoidConversion: boolean;
  baseCustomizableChartService: Type<BaseCustomizableChartService>;
  baseCustomizableChartDataService: Type<BaseCustomizableChartDataService>;

  constructor(init: Partial<GenericChartsModuleSettings>) {
    Object.assign(this, init);
  }
}
